module.exports = __webpack_public_path__ + "static/manager-46fcd64444bde45a7d82cb2b7b996372.png";